import React, { useState } from 'react';
import { translate } from '../../Services/translation';
import FilterMenu from './FilterMenu';
import { useTypedSelector } from '../../Hooks/useTypedSelector';

type CurrentMenuType = 'categories' | 'filters' | 'sorting';

const FilterBarButtons = () => {
  const [currentMenu, setCurrentMenu] = useState<
    CurrentMenuType | undefined
  >();
  const { subNavigation } = useTypedSelector(
    (state) => state.productFiltering
  );

  return (
    <>
      <div className="flex gap-4 pb-4 lg:hidden">
        {!!subNavigation.links.length && (
          <button
            className="btn btn--small flex-1 border-gray-400 bg-white text-gray-900 hover:bg-gray-100"
            onClick={() => setCurrentMenu('categories')}
          >
            {translate('filter.categories')}
          </button>
        )}
        <button
          className="btn btn--small flex-1 border-gray-400 bg-white text-gray-900 hover:bg-gray-100"
          onClick={() => setCurrentMenu('filters')}
        >
          {translate('filter.filter')}
        </button>
        <button
          className="btn btn--small flex-1 border-gray-400 bg-white text-gray-900 hover:bg-gray-100"
          onClick={() => setCurrentMenu('sorting')}
        >
          {translate('filter.sort')}
        </button>
      </div>

      <FilterMenu
        currentMenu={currentMenu}
        setCurrentMenu={setCurrentMenu}
      />
    </>
  );
};

export default FilterBarButtons;
